import React from "react";
import { useContext } from "react";
import styled from "styled-components";
import { LockOutlined, SafetyOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import { AuthContext } from "../context/AuthProvider";
import { hasClosingVaultAccess } from "../helpers/accountProduct";
import ScaleUpgradeModal from "../components/ScaleUpgradeModal";

export default function ClosingVaultPage() {
  const { userInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const [upgradeOpen, setUpgradeOpen] = React.useState(false);

  const hasAccess = hasClosingVaultAccess(userInfo);

  if (!hasAccess) {
    return (
      <Container>
        <GateCard>
          <LockOutlined style={{ fontSize: 40, color: "#6b7280", marginBottom: 16 }} />
          <h2>Closing Vault</h2>
          <p>
            The sale-ready portfolio packet (rent roll, lease history, and
            investor-grade exports) is included with the full LandlordOps OS on
            every plan. Need more doors? Upgrade your door cap via Billing.
          </p>
          <Button variant="primary" onClick={() => setUpgradeOpen(true)}>
            View billing
          </Button>
        </GateCard>
        <ScaleUpgradeModal open={upgradeOpen} onClose={() => setUpgradeOpen(false)} />
      </Container>
    );
  }

  return (
    <Container>
      <ComingSoonCard>
        <SafetyOutlined style={{ fontSize: 48, color: "#2c5f2d", marginBottom: 16 }} />
        <h1>Closing Vault</h1>
        <Badge>Coming Soon</Badge>
        <p>
          Generating your first automated sale-ready packet. This feature will be
          live shortly for all LandlordOps subscribers.
        </p>
        <WhatToExpect>
          <h3>What you'll get</h3>
          <ul>
            <li>Current rent roll pulled from your live portfolio</li>
            <li>Full lease history per door</li>
            <li>Expense summary and Schedule E data</li>
            <li>One-click export formatted for buyer due diligence or refi lenders</li>
          </ul>
        </WhatToExpect>
        <Button variant="secondary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </Button>
      </ComingSoonCard>
    </Container>
  );
}

const Container = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
`;

const GateCard = styled.div`
  max-width: 520px;
  text-align: center;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 3rem 2rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);

  h2 {
    font-size: 1.6rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.75rem;
  }

  p {
    color: #6b7280;
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }
`;

const ComingSoonCard = styled.div`
  max-width: 560px;
  text-align: center;
  background: #fff;
  border: 2px solid #2c5f2d;
  border-radius: 16px;
  padding: 3rem 2rem;
  box-shadow: 0 4px 24px rgba(44, 95, 45, 0.1);

  h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.5rem;
  }

  p {
    color: #4b5563;
    font-size: 1rem;
    line-height: 1.6;
    margin: 1rem 0 1.5rem;
  }
`;

const Badge = styled.span`
  display: inline-block;
  background: #f0fdf4;
  color: #2c5f2d;
  border: 1px solid #86efac;
  border-radius: 999px;
  padding: 4px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  margin-bottom: 0.5rem;
`;

const WhatToExpect = styled.div`
  background: #f9fafb;
  border-radius: 10px;
  padding: 1.25rem 1.5rem;
  margin: 1rem 0 1.5rem;
  text-align: left;

  h3 {
    font-size: 0.95rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 0.75rem;
  }

  ul {
    margin: 0;
    padding-left: 1.25rem;
    color: #4b5563;
    font-size: 0.9rem;
    line-height: 1.7;
  }
`;
